import { useRouter } from "next/router";

export interface UrlProps {
  url?: string;
}

export function useUrl() {
  const router = useRouter();
  if (typeof router.query.seasonId !== "string") throw new Error("no seasonid");
  // const [seasonId, setSeasonId] = useState(router.query.seasonId);
  const seasonId = router.query.seasonId;
  // useEffect(() => {
  //   if (typeof router.query.seasonId === "string") {
  //     setSeasonId(router.query.seasonId);
  //   } else {
  //     router.push("/admin");
  //   }
  // }, [router]);

  function push(url: string) {
    router.push("/" + router.locale + "/admin/" + seasonId + url);
  }

  function customUrl(url: string) {
    return "/" + router.locale + "/admin/" + seasonId + url;
  }

  function changeSeason(seasonId: string) {
    router.push(
      "/" +
        router.locale +
        "/admin/" +
        seasonId +
        "/" +
        router.pathname.split("/").slice(3).join("/")
    );
  }

  function changeSeasonAndPush(seasonId: string, url: string) {
    router.push("/" + router.locale + "/admin/" + seasonId + url);
  }

  return { push, seasonId, changeSeason, customUrl, changeSeasonAndPush };
}
